import { render, staticRenderFns } from "./HeaderClient.vue?vue&type=template&id=2744a218&scoped=true"
import script from "./HeaderClient.vue?vue&type=script&lang=ts"
export * from "./HeaderClient.vue?vue&type=script&lang=ts"
import style0 from "./HeaderClient.vue?vue&type=style&index=0&id=2744a218&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744a218",
  null
  
)

export default component.exports